import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { useDataProvider } from '../../mtska-frontend-data-provider';

const SettingsContext = React.createContext({
    // per accedere a proprietà e metodi di gestione dei settings usare useSettingsContext.js
    settings: null,
    settingsLoaded: null,
    hello: () => { console.error('Stai girando fuori dal ContextSettings') },
    setSettings: () => { console.error('Stai girando fuori dal ContextSettings') },
    saveSettings: () => { console.error('Stai girando fuori dal ContextSettings') },
})

export const SettingsContextProvider = ({ children }) => {
    const [settingsLoaded, setSettingsLoaded] = useState(false);
    const [settings, setSettings] = useState({});
    const { loadAll: loadSettings, save: saveSettings } = useDataProvider('settings/setting');
    const token = sessionStorage.getItem('token');

    const stableSetSettings = useCallback((newSettings) => {
        // console.info('QUESTO DEVE ESSERE IL TERZO SettingsContext:stableSetSettings ricevo', newSettings, Date.now())
        setSettings(newSettings);
        setSettingsLoaded(true)
    }, []);

    const hello = useCallback(() => {
        // metodo per arrivare a livello di SettingsContext in fase di debug, per vedere il valore degli stati
        const _settings = settings;
        const _settingsLoaded = settingsLoaded;
        const _hello = 'world';
    }, []);

    useEffect(() => {
        // console.info('QUESTO DEVE ESSERE IL PRIMO ++++++SettingsContext:useEffect[settings] Settings AGGIORNATI:', settings, 'caricati', settingsLoaded);
    }, [settings]);

    useEffect(() => {
        // console.info('SettingsContext:useEffect[token] controllo se ho token e non ho settings', settings, token)
        if (token) {
            // console.info('SettingsContext:useEffect[token] richiedo settings')
            loadSettings().then((res) => {
                // console.info('QUESTO DEVE ESSERE IL SECONDO SettingsContext:useEffect[token] settings ricevuti', res?.items?.data)
                stableSetSettings(res?.items?.data);
            });
        }
    }, [token]);

    const config = useMemo(() => ({
        settings,
        settingsLoaded,
        hello,
        setSettings: stableSetSettings,
        saveSettings,
    }), [settings, settingsLoaded, stableSetSettings, saveSettings]);

    return (
        <SettingsContext.Provider value={config}>
            {children}
        </SettingsContext.Provider>
    );
};

export default SettingsContext;

